import { render, staticRenderFns } from "./Separator.vue?vue&type=template&id=7ca80e31&"
import script from "./Separator.vue?vue&type=script&lang=js&"
export * from "./Separator.vue?vue&type=script&lang=js&"
import style0 from "./Separator.vue?vue&type=style&index=0&id=7ca80e31&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports